import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';

import { ArticleApiService } from './api/article/article-api.service';
import { AgilityApiService } from './api/agility/agility-api.service';
import { HttpWrapperService } from './api/common/http-wrapper/http-wrapper.service';
import { NewswireComponent } from './components/newswire/newswire.component';
import { NewsroomApiService } from './api/newsroom/newsroom-api.service';
import { ArticleComponent } from './components/article/article.component';

import { IndustryApiService } from './api/industry/industry-api.service';
import { PreferredMethodOfContactApiService } from './api/preferred-method-of-contact/preferred-method-of-contact-api.service';
import { AccountApiService } from './api/account/account-api.service';
import { TimeHelper } from '../../Common/Forms/helpers/time.helper';
import { CommonDialogsModule } from '../../Common/Dialogs/common-dialogs.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { NewsSharedModule } from '../Shared/news-shared.module';
import { NewsRightSideBarComponent } from './components/news-right-side-bar/news-right-side-bar.component';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { LayoutModule } from '../../Common/Layout/layout.module';

@NgModule({
    declarations: [
        NewswireComponent,
        ArticleComponent,
        NewsRightSideBarComponent
    ],
    imports: [
        InputTextModule,
        MultiSelectModule,
        FormsModule,
        DatePickerModule,
        CommonModule,
        TextareaModule,
        SelectModule,
        CommonDialogsModule,
        TooltipModule,
        MiscModule,
        CommonFormsModule,
        CheckboxModule,
        NewsSharedModule,
        CommonBasicModule,
        LayoutModule
    ],
    exports: [
        NewswireComponent,
    ],
    providers: [
        ArticleApiService,
        HttpWrapperService,
        AgilityApiService,
        NewsroomApiService,
        IndustryApiService,
        PreferredMethodOfContactApiService,
        AccountApiService,
        TimeHelper
    ]
})
export class NewswireModule { }
